import { HttpClient } from '@angular/common/http';
import { forwardRef, NgModule } from '@angular/core';
import { CoreHttpClient } from './core-http.client';

@NgModule({
  providers: [
    forwardRef(() => ({ provide: CoreHttpClient, useClass: HttpClient }))
  ]
})
export class CoreTestingModule {}
